export const skills = [
    "JavaScript ES6+",
    "React",
    "React Hooks",
    "React Router",
    "Redux Toolkit",
    "Redux Saga",
    "React Native",
    "Expo",
    "Expo Router",
    "react-native-video",
    "AsyncStorage",
    "Working with API",
    "Error handling",
    "Immutability",
    "Styled Components",
    "Semantic and accessible HTML",
    "Responsive Web Design",
    "CSS Flexbox",
    "CSS Grid",
    "CSS BEM convention",
    "SEO basics",
    "Graphic design",
    "Photo editing",
    "Adobe software",
    "Blender software",
    "Commercial photography",
    "Creating 360° virtual tours",
    "Network administration",
    "Website services administration",
    "Database administration",
    "System administration",
    "GitHub Pull Requests and Review",
    "Teamwork",
    "Problem-solving",
    "Organizational skills",
    "Interpersonal skills",
    "Social media communication",
    "Social media copywriting"
];

export const nextSkills = [
    "Python",
    "Bash",
    "Docker",
    "Grafana",
    "Sentry",
    "Backend",
    "Teamwork on large-scale projects",
    "Code reviews",
    "Cloud services (AWS, Google Cloud)"
];